(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[739],{

/***/ 7989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/[show]/episode/[episode]",
      function () {
        return __webpack_require__(9806);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4913);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(651);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2379);
/* harmony import */ var store_podcast_episodes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1031);
/* harmony import */ var pages_error_page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1346);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4469);
/* harmony import */ var components_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8784);
/* harmony import */ var store_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1142);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5443);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(744);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);










var MoreButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().loadMoreContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            container: true,
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().loadMoreButtonContainer),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: onClick,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().loadMoreButton),
                children: "Load More"
            })
        })
    });
};
var EpisodesList = function(param) {
    var episodes = param.episodes, slug = param.slug, loadMoreEpisodes = param.loadMoreEpisodes, expanded = param.expanded;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().episodesContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().episodes),
            children: [
                episodes.map(function(ep) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: "/podcasts/".concat(slug, "/episode/").concat(ep.slug),
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().episode),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                alt: "".concat(ep.title, " Cover Art"),
                                src: (0,shared_util__WEBPACK_IMPORTED_MODULE_4__/* .imageUrl */ .sQ)({
                                    id: ep.coverArt ? ep.coverArt : ep.podcastShow.coverArt,
                                    width: 46,
                                    height: 46
                                }),
                                height: 46,
                                width: 46
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().episodeData), expanded ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().episodeDataExpanded) : ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().episodeTitle),
                                        children: ep.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().date),
                                        children: (0,shared_util__WEBPACK_IMPORTED_MODULE_4__/* .formatDateTime */ .o0)(ep.publishedAt, "mm/dd/yyyy")
                                    })
                                ]
                            })
                        ]
                    }, ep.id);
                }),
                loadMoreEpisodes ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MoreButton, {
                    onClick: loadMoreEpisodes
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().loadMoreContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        container: true,
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().loadMoreButtonContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().loadMoreButton),
                            children: "Loading..."
                        })
                    })
                })
            ]
        })
    });
};
var PodcastEpisodeListing = function(param) {
    var slug = param.slug, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _excluded = param.excluded, excluded = _excluded === void 0 ? [] : _excluded;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), offset = ref[0], setOffset = ref[1];
    var episodesL = store_podcast_episodes__WEBPACK_IMPORTED_MODULE_2__/* .getPodcastEpisodes */ .f({
        podcastShowSlug: slug,
        offset: offset,
        limit: 5
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), previousEpisodes = ref1[0], setPreviousEpisodes = ref1[1];
    switch(episodesL._tag){
        case "NotFound":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_error_page__WEBPACK_IMPORTED_MODULE_3__["default"], {
                statusCode: 404
            });
        case "NotLoaded":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EpisodesList, {
                episodes: previousEpisodes,
                slug: slug,
                expanded: expanded
            });
        case "Loaded":
            {
                var newEpisodes = store_util__WEBPACK_IMPORTED_MODULE_6__/* .Loadable.getOrElse */ .Pn.getOrElse([], episodesL);
                var allEpisodes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(previousEpisodes).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(newEpisodes)).filter(function(ep) {
                    return excluded.indexOf(ep.id) < 0;
                });
                var loadMoreEpisodes = function(e) {
                    e.preventDefault();
                    (0,shared_util__WEBPACK_IMPORTED_MODULE_4__/* .batchUpdates */ .j9)(function() {
                        setPreviousEpisodes(function(ep) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(ep).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(newEpisodes));
                        });
                        setOffset(function(prevOffset) {
                            return prevOffset + 5;
                        });
                    });
                };
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EpisodesList, {
                    episodes: allEpisodes,
                    slug: slug,
                    loadMoreEpisodes: loadMoreEpisodes,
                    expanded: expanded
                });
            }
        default:
            return (0,shared_util__WEBPACK_IMPORTED_MODULE_4__/* .exhaustive */ .EO)(episodesL);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (PodcastEpisodeListing);


/***/ }),

/***/ 9806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _episode_page; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(651);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(2379);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.3_9400d357419a594fac66ebea8b370ed9/node_modules/next/router.js
var next_router = __webpack_require__(6207);
// EXTERNAL MODULE: ../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/bind.js
var bind = __webpack_require__(2034);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./pages/_error.page.tsx
var _error_page = __webpack_require__(1346);
// EXTERNAL MODULE: ./shared/feature.ts
var shared_feature = __webpack_require__(2507);
// EXTERNAL MODULE: ./shared/util.ts + 2 modules
var util = __webpack_require__(4469);
// EXTERNAL MODULE: ./store/podcast-episodes.ts
var podcast_episodes = __webpack_require__(1031);
// EXTERNAL MODULE: ./store/podcasts.ts
var podcasts = __webpack_require__(7328);
// EXTERNAL MODULE: ./store/videos.ts
var videos = __webpack_require__(7247);
// EXTERNAL MODULE: ./components/Header/index.tsx + 3 modules
var components_Header = __webpack_require__(3836);
// EXTERNAL MODULE: ./components/Footer/index.tsx
var components_Footer = __webpack_require__(7489);
// EXTERNAL MODULE: ./store/util.ts
var store_util = __webpack_require__(1142);
// EXTERNAL MODULE: ./components/PodcastEpisodeListing/index.tsx
var PodcastEpisodeListing = __webpack_require__(7843);
// EXTERNAL MODULE: ./components/DisplayAd/index.tsx
var DisplayAd = __webpack_require__(1362);
// EXTERNAL MODULE: ./components/Grid/index.tsx
var Grid = __webpack_require__(8784);
// EXTERNAL MODULE: ./components/CopyLinkButton/index.tsx
var CopyLinkButton = __webpack_require__(7274);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(3819);
// EXTERNAL MODULE: ./components/RecirculationCarousel/index.tsx + 4 modules
var RecirculationCarousel = __webpack_require__(5495);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.3_9400d357419a594fac66ebea8b370ed9/node_modules/next/head.js
var head = __webpack_require__(9828);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Meta.tsx
var Meta = __webpack_require__(7456);
// EXTERNAL MODULE: ./shared/ga.ts
var ga = __webpack_require__(9690);
;// CONCATENATED MODULE: ./pages/podcasts/[show]/episode/Meta.tsx






var structuredData = function(podcastEpisode) {
    var publishedDate = new Date(podcastEpisode.publishedAt * 1000).toISOString();
    var keywords = podcastEpisode.podcastShow.hosts.map(function(h) {
        return h.name;
    }).join(",");
    var url = "https://therecount.com/podcasts/".concat(podcastEpisode.podcastShow.slug, "/episode/").concat(podcastEpisode.slug);
    var coverArt = podcastEpisode.coverArt || podcastEpisode.podcastShow.coverArt;
    return {
        "@context": "http://schema.org",
        "@type": "NewsArticle",
        mainEntityOfPage: {
            "@type": "PodcastEpisode",
            "@id": url,
            name: podcastEpisode.title,
            description: podcastEpisode.description,
            thumbnailUrl: (0,util/* imageUrl */.sQ)({
                id: coverArt,
                width: 1200
            }),
            dateCreated: publishedDate
        },
        url: url,
        headline: podcastEpisode.title,
        thumbnailUrl: (0,util/* imageUrl */.sQ)({
            id: coverArt,
            width: 1280
        }),
        image: {
            "@type": "ImageObject",
            url: (0,util/* imageUrl */.sQ)({
                id: coverArt,
                width: 1280
            }),
            width: 1280,
            height: 1280
        },
        datePublished: publishedDate,
        dateModified: publishedDate,
        publisher: {
            "@type": "Organization",
            name: "The Recount",
            logo: {
                "@type": "ImageObject",
                url: Meta/* defaults.logoURL */.ce.logoURL
            }
        },
        articleSection: podcastEpisode.podcastShow.name,
        description: podcastEpisode.description,
        keywords: keywords
    };
};
var Meta_Meta = function(param) {
    var podcastEpisode = param.podcastEpisode;
    // TODO Audio player card for twitter
    var publishedDate = new Date(podcastEpisode.publishedAt * 1000).toISOString();
    var keywords = podcastEpisode.podcastShow.hosts.map(function(h) {
        return h.name;
    }).join(",");
    var url = "https://therecount.com/podcasts/".concat(podcastEpisode.podcastShow.slug, "/episode/").concat(podcastEpisode.slug);
    var coverArt = podcastEpisode.coverArt || podcastEpisode.podcastShow.coverArt;
    (0,react.useEffect)(function() {
        (0,ga/* logPageView */.Nc)({
            pathname: window.location.pathname
        });
    }, []);
    // TODO: Add ids to the .env
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            (0,Meta/* baseMeta */.Pv)({
                title: podcastEpisode.title,
                description: podcastEpisode.description,
                keywords: keywords
            }),
            (0,Meta/* twitterMeta */.AC)({
                image: (0,util/* imageUrl */.sQ)({
                    id: coverArt,
                    width: 1500
                })
            }),
            (0,Meta/* openGraphMeta */.ZI)({
                type: "article",
                image: {
                    id: coverArt,
                    width: 1280,
                    height: 1280
                },
                title: podcastEpisode.title,
                description: podcastEpisode.description,
                url: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:section",
                content: podcastEpisode.podcastShow.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:published_time",
                content: publishedDate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:modified_time",
                content: publishedDate
            }),
            (0,Meta/* jsonLd */.oL)(structuredData(podcastEpisode))
        ]
    });
};


// EXTERNAL MODULE: ./pages/podcasts/[show]/episode/[episode].module.scss
var _episode_module = __webpack_require__(3434);
var _episode_module_default = /*#__PURE__*/__webpack_require__.n(_episode_module);
;// CONCATENATED MODULE: ./pages/podcasts/[show]/episode/[episode].page.tsx






















var AD_SLOT_1 = "/22673562521/Responsive_DisplayAds_ATF";
var AD_SLOT_2 = "/22673562521/Responsive_DisplayAds_BTF";
var Details = function(param) {
    var episode = param.episode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (_episode_module_default()).playerTitleDesc,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (_episode_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    title: "Podcast Player",
                    loading: "lazy",
                    className: (_episode_module_default()).iframe,
                    src: "https://embed.acast.com/".concat(episode.podcastShow.acastShowId, "/").concat(episode.acastEpisodeId),
                    frameBorder: "0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (_episode_module_default()).episodeTitle,
                    children: episode.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (_episode_module_default()).episodeDescription,
                    dangerouslySetInnerHTML: {
                        __html: episode.description
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (_episode_module_default()).socialIcons,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyLinkButton/* default */.Z, {
                            clipboardText: "https://therecount.com/"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://twitter.com/therecount",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Twitter */.Z.Twitter, {
                                color: "#fff"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.facebook.com/TheRecount/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Facebook */.Z.Facebook, {
                                color: "#fff"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var SubscribeLinks = function(param) {
    var links = param.links;
    var platformIcons = {
        apple: "/podcastServices/apple.svg",
        google: "/podcastServices/google.svg",
        spotify: "/podcastServices/spotify.svg"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        justifyContent: "center",
        gap: ".5rem",
        className: (_episode_module_default()).subscribeLinks,
        children: links.map(function(l) {
            var icon = platformIcons[l.type];
            var iconImg = icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (_episode_module_default()).icon,
                src: icon,
                height: 12,
                width: 12
            }) : null;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: (_episode_module_default()).subscribeLink,
                href: l.url,
                children: [
                    iconImg,
                    " ",
                    l.title
                ]
            }, l.url);
        })
    });
};
var Transcript = function(param) {
    var transcript = param.transcript;
    var ref = (0,react.useState)(false), transcriptIsOpen = ref[0], setTranscriptIsOpen = ref[1];
    var transcriptStyles = bind_default()((_episode_module_default()).transcriptText, transcriptIsOpen ? (_episode_module_default()).open : (_episode_module_default()).collapsed);
    var caretClass = bind_default()((_episode_module_default()).caret, transcriptIsOpen ? (_episode_module_default()).caretUp : (_episode_module_default()).caretDown);
    if (transcript) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: (_episode_module_default()).transcriptTitle,
                    onClick: function() {
                        return setTranscriptIsOpen(function(v) {
                            return !v;
                        });
                    },
                    children: [
                        "transcript",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: caretClass,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Caret */.Z.Caret, {
                                color: "#000"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: transcriptStyles,
                    dangerouslySetInnerHTML: {
                        __html: (0,util/* renderRichText */.Zm)(transcript)
                    }
                })
            ]
        });
    }
    return null;
};
var PodcastEpisodePage = function() {
    var router = (0,next_router.useRouter)();
    var showSlug = router.query.show;
    var episodeSlug = router.query.episode;
    var feature = (0,shared_feature/* default */.Z)();
    var episodeL = podcast_episodes/* getBySlug */.W(episodeSlug);
    var show_ = podcasts/* getBySlug */.W(showSlug);
    var relatedVideosL = videos/* getByShow */.Y$({
        show: store_util/* Loadable.map */.Pn.map(show_, function(s) {
            return s.showId;
        }),
        limit: 12
    });
    var Header = (0,components_Header/* useHeader */.g)();
    var Footer = (0,components_Footer/* useFooter */.T)();
    if (!feature.isOn("recount-redesign")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_error_page["default"], {
            statusCode: 404
        });
    }
    (0,react.useEffect)(function() {
        store_util/* Loadable.forEach */.Pn.forEach(episodeL, function(e) {
            if (e.podcastShow.slug !== showSlug) {
                window.history.replaceState(null, "", "/podcasts/".concat(showSlug, "/episode/").concat(episodeSlug));
            }
        });
    }, []);
    switch(episodeL._tag){
        case "NotFound":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(_error_page["default"], {
                statusCode: 404
            });
        case "NotLoaded":
            return null; // TODO loading state
        case "Loaded":
            {
                var recirc = null; // TODO loading state
                store_util/* Loadable.forEach */.Pn.forEach(relatedVideosL, function(vs) {
                    recirc = /*#__PURE__*/ (0,jsx_runtime.jsx)(RecirculationCarousel/* RecirculationCarousel */.r, {
                        videos: vs,
                        title: "Watch Highlights"
                    });
                });
                var episode = episodeL.data;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta_Meta, {
                            podcastEpisode: episode
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                            episode: episode
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (_episode_module_default()).wrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeLinks, {
                                    links: episode.podcastShow.subscribeLinks
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Transcript, {
                                    transcript: episode.transcript
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAd/* DisplayAd */.D, {
                                    adSlot: AD_SLOT_1,
                                    currentPath: "/podcasts/".concat(showSlug, "/").concat(episodeSlug)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (_episode_module_default()).recentEpisodesTitle,
                                    children: "Recent Episodes"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PodcastEpisodeListing/* default */.Z, {
                                    slug: showSlug,
                                    expanded: true,
                                    excluded: [
                                        episode.id
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_episode_module_default()).recirculationConatiner,
                            children: recirc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAd/* DisplayAd */.D, {
                            adSlot: AD_SLOT_2,
                            currentPath: "/podcasts/".concat(showSlug, "/").concat(episodeSlug)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                    ]
                });
            }
        default:
            return (0,util/* exhaustive */.EO)(episodeL);
    }
};
/* harmony default export */ var _episode_page = (PodcastEpisodePage);


/***/ }),

/***/ 2507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7219);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6207);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2452);



var deployedFeatures = [
    "recount-redesign"
];
var useFeature = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_cookie__WEBPACK_IMPORTED_MODULE_1__/* .useCookies */ .f)(), 1), getCookie = ref[0];
    var isOn = function(feature) {
        return deployedFeatures.includes(feature) || (router.query["f-".concat(feature)] || getCookie("feature-".concat(feature))) === "true";
    };
    return {
        isOn: isOn
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFeature);


/***/ }),

/***/ 1031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getBySlug; },
/* harmony export */   "f": function() { return /* binding */ getPodcastEpisodes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2823);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9345);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9640);
/* harmony import */ var _fragments__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4125);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1142);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetPodcastEpisodes($podcastShowSlug: String!, $offset: Int, $limit: Int) {\n      podcastEpisodes(podcastShowSlug: $podcastShowSlug, offset: $offset, limit: $limit) {\n        ",
        "\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PodcastEpisodeBySlug {\n      \n    podcastEpisode(slug:"',
        '") {\n        ',
        "\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var getPodcastEpisodes = function(param) {
    var podcastShowSlug = param.podcastShowSlug, offset = param.offset, limit = param.limit;
    var ref = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject(), _fragments__WEBPACK_IMPORTED_MODULE_1__/* .podcastEpisode */ .oe), {
        variables: {
            podcastShowSlug: podcastShowSlug,
            offset: offset,
            limit: limit
        }
    }), data = ref.data, loading = ref.loading;
    if (data === undefined || loading) {
        return _util__WEBPACK_IMPORTED_MODULE_2__/* .NotLoaded */ .o2;
    }
    return (0,_util__WEBPACK_IMPORTED_MODULE_2__/* .Loaded */ .sh)(data.podcastEpisodes);
};
var episodeBySlugQuery = function(slug) {
    return (0,graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject1(), slug, _fragments__WEBPACK_IMPORTED_MODULE_1__/* .podcastEpisode */ .oe);
};
var getBySlug = function(slug) {
    var data = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(episodeBySlugQuery(slug)).data;
    if (data === undefined) {
        return _util__WEBPACK_IMPORTED_MODULE_2__/* .NotLoaded */ .o2;
    }
    if (data.podcastEpisode === null) {
        return _util__WEBPACK_IMPORTED_MODULE_2__/* .NotFound */ .TX;
    }
    return (0,_util__WEBPACK_IMPORTED_MODULE_2__/* .Loaded */ .sh)(data.podcastEpisode);
};



/***/ }),

/***/ 7328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getBySlug; },
/* harmony export */   "g": function() { return /* binding */ getAll; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2823);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9345);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9640);
/* harmony import */ var _fragments__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4125);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1142);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query AllPodcasts {\n    podcastShows {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query PodcastBySlug {\n      podcastShow(slug:"',
        '") {\n        ',
        "\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var podcastsQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_templateObject(), _fragments__WEBPACK_IMPORTED_MODULE_1__/* .podcastShow */ .nA);
var podcastBySlugQuery = function(slug) {
    return (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_templateObject1(), slug, _fragments__WEBPACK_IMPORTED_MODULE_1__/* .podcastShow */ .nA);
};
var getBySlug = function(slug) {
    var data = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(podcastBySlugQuery(slug)).data;
    if (data === undefined) {
        return _util__WEBPACK_IMPORTED_MODULE_2__/* .NotLoaded */ .o2;
    }
    if (data.podcastShow === null) {
        return _util__WEBPACK_IMPORTED_MODULE_2__/* .NotFound */ .TX;
    }
    return (0,_util__WEBPACK_IMPORTED_MODULE_2__/* .Loaded */ .sh)(data.podcastShow);
};
var getAll = function() {
    var data = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(podcastsQuery).data;
    if (data === undefined) {
        return _util__WEBPACK_IMPORTED_MODULE_2__/* .NotLoaded */ .o2;
    }
    return (0,_util__WEBPACK_IMPORTED_MODULE_2__/* .Loaded */ .sh)(data.podcastShows);
};



/***/ }),

/***/ 744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"episodesContainer":"PodcastEpisodeListing_episodesContainer__hTpPV","title":"PodcastEpisodeListing_title__vhGQN","episode":"PodcastEpisodeListing_episode__Z8oHd","episodeTitle":"PodcastEpisodeListing_episodeTitle__O3Dfk","date":"PodcastEpisodeListing_date__kbTnz","episodeData":"PodcastEpisodeListing_episodeData__ghxLH","episodeDataExpanded":"PodcastEpisodeListing_episodeDataExpanded__5yNPQ","loadMoreContainer":"PodcastEpisodeListing_loadMoreContainer__ayNvV","loadMoreButton":"PodcastEpisodeListing_loadMoreButton__pXWYL"};

/***/ }),

/***/ 3434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_episode__wrapper__NPeP_","iframe":"_episode__iframe__SSmZt","playerTitleDesc":"_episode__playerTitleDesc__IAA_b","episodeTitle":"_episode__episodeTitle__AZpdw","socialIcons":"_episode__socialIcons__TIaGI","subscribeLinks":"_episode__subscribeLinks__LPgil","subscribeLink":"_episode__subscribeLink__5_g9j","transcriptTitle":"_episode__transcriptTitle__k447_","caret":"_episode__caret__PNz3v","caretDown":"_episode__caretDown__bwwXL","caretUp":"_episode__caretUp__f4SZe","transcriptText":"_episode__transcriptText__xS0aV","open":"_episode__open__h9uJ8","recentEpisodesTitle":"_episode__recentEpisodesTitle__5N3WU","recirculationConatiner":"_episode__recirculationConatiner__DQAE4"};

/***/ }),

/***/ 4913:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(7132);
;// CONCATENATED MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(4690);
;// CONCATENATED MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(9079);
;// CONCATENATED MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(7989); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);